import React, { useEffect, useState, useMemo, useContext } from 'react';
import { Scatter } from 'react-chartjs-2';
import LoadingTable from '../LoadingTable';
import Axios from "axios";
import { thai_date, checkGroupsUser, getlocalStorage, handleResizeDisplay } from '../../function/functionALL';
import "../../components/style.css";
import { YearContext } from '../usecontext/YearContext';
import Swal from "sweetalert2";
import bmi from "../../img/bmi.png"

const BMIChartComponent = ({ showChartBMI, unitname, all_round }) => {
    const [bmiData1, setBmiData1] = useState([]);
    const [bmiData2, setBmiData2] = useState([]);
    const [bmiDatasummary1, setBmiDatasummary1] = useState([]);
    const [bmiDatasummary2, setBmiDatasummary2] = useState([]);
    const [loading, setLoading] = useState(true);
    const { Token, DataToken_ } = getlocalStorage();
    const role = checkGroupsUser(DataToken_.groups)
    const role_openRole = role?.openRole
    const [chartReady, setChartReady] = useState(false);
    const DateTime = new Date()
    const { yearcurrent } = useContext(YearContext);
    const [isStacked, setIsStacked] = useState(false);



    useEffect(() => {
        handleResizeDisplay(setIsStacked);
        if (unitname === undefined) {
            GetBMI1();
            GetBMI2();
            GetBMI1_summary1();
            GetBMI1_summary2();

        } else {
            GetBMI1unit();
            GetBMI2unit();
            GetBMI1Unit_summary1();
            GetBMI2Unit_summary2();
        }


    }, [yearcurrent, unitname]);

    // useEffect(() => {
    //     if (bmiData1.length > 0) {

    //         setChartReady(true);
    //     }
    // }, [bmiData1]);
    // useEffect(() => {
    //     if (bmiData2.length > 0) {

    //         setChartReady(true);
    //     }
    // }, [bmiData2]);


    const GetBMI1 = async () => {
        try {
            setLoading(true)

            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `all_tester_data/?year=${yearcurrent}&round=1`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });
            let allData = response.data;
            // console.log("allDataBMI1", allData)
            if (allData === undefined) {
                setBmiData1([]);

            } else {
                setBmiData1(allData);
            }
            setLoading(false);

        } catch (error) {

            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };
    const GetBMI2 = async () => {
        try {


            setLoading(true)
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `all_tester_data/?year=${yearcurrent}&round=2`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });
            let allData = response.data;
            // console.log("allDataBMI2", allData)

            if (allData === undefined) {
                setBmiData2([]);
            } else {
                setBmiData2(allData);
            }
            setLoading(false);
        } catch (error) {

            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };

    const GetBMI1unit = async () => {
        try {
            setLoading(true)

            const selectedRound = all_round.find((roundData) => roundData.round === 1);
            // console.log("selectedRound", selectedRound)

            if (selectedRound === undefined) {
                setBmiData1([]);
            } else {
                const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `${selectedRound.id}/tester_data/`, {
                    headers: {
                        Authorization: "Token " + Token,
                    },
                });
                let allData = response.data;
                // console.log("allDataBMI1unit", allData)

                setBmiData1(allData);
            }
            setLoading(false);


        } catch (error) {

            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };
    const GetBMI2unit = async () => {
        try {

            const selectedRound = all_round.find((roundData) => roundData.round === 2);
            // console.log("selectedRound", selectedRound)
            if (selectedRound === undefined) {
                setBmiData2([]);
            } else {
                const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `${selectedRound.id}/tester_data/`, {
                    headers: {
                        Authorization: "Token " + Token,
                    },
                });
                let allData = response.data;
                // console.log("allDataBMI2unit", allData)

                setBmiData2(allData);
            }
            setLoading(false);

        } catch (error) {

            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };

    const GetBMI1_summary1 = async () => {
        try {
            setLoading(true)

            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `summary_tester_data/?year=${yearcurrent}&round=1`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });
            let allData = response.data;
            if (allData === undefined) {
                setBmiDatasummary1([]);

            } else {
                setBmiDatasummary1(allData);
            }
            setLoading(false);

        } catch (error) {

            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };

    const GetBMI1_summary2 = async () => {
        try {
            setLoading(true)

            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `summary_tester_data/?year=${yearcurrent}&round=2`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });
            let allData = response.data;
            if (allData === undefined) {
                setBmiDatasummary2([]);

            } else {
                setBmiDatasummary2(allData);
            }
            setLoading(false);

        } catch (error) {

            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };

     const GetBMI1Unit_summary1 = async () => {
        try {
            setLoading(true)

            const selectedRound = all_round.find((roundData) => roundData.round === 1);
            // console.log("selectedRound", selectedRound.id)

            if (selectedRound === undefined) {
                setBmiDatasummary1([]);
            } else {
                const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `summary_tester_data?test_round_id=${selectedRound.id}`, {
                    
                    headers: {
                        Authorization: "Token " + Token,
                    },
                });
                let allData = response.data;
                

                setBmiDatasummary1(allData);
            }
            setLoading(false);


        } catch (error) {

            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };
    const GetBMI2Unit_summary2 = async () => {
        try {

            const selectedRound = all_round.find((roundData) => roundData.round === 2);
            // console.log("selectedRound", selectedRound)
            if (selectedRound === undefined) {
                setBmiDatasummary2([]);
            } else {
                const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `summary_tester_data?test_round_id=${selectedRound.id}`, {
                    headers: {
                        Authorization: "Token " + Token,
                    },
                });
                let allData = response.data;
                // console.log("allDataBMI2unit", allData)

                setBmiDatasummary2(allData);
            }
            setLoading(false);

        } catch (error) {

            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
                icon: "error",
                text: "มีข้อมูลไม่ครบตามวงรอบ"

            });
        }
    };

    const bmiData_1 = useMemo(() => {
        return Array.isArray(bmiData1) ? bmiData1.map(item => {
            const height = parseFloat(item.body_data.height);
            const weight = parseFloat(item.body_data.weight);
            const bmi = parseFloat(item.body_data.bmi);

            return { x: height, y: weight, bmi };
        }) : [];
    }, [bmiData1]);


    const bmiData_2 = useMemo(() => {
        return Array.isArray(bmiData2) ? bmiData2.map(item => {
            const height = parseFloat(item.body_data.height);
            const weight = parseFloat(item.body_data.weight);
            const bmi = parseFloat(item.body_data.bmi);

            return { x: height, y: weight, bmi };
        }) : [];
    }, [bmiData2]);

    const getPointColor = (height, weight) => {
        const thresholds = [
            { max: 40 + ((80 - 40) / (208 - 148)) * (height - 148), color: 'rgba(173, 216, 230, 1)' },  // ต่ำกว่าเกณฑ์
            { max: 48 + ((95 - 48) / (208 - 148)) * (height - 148), color: 'rgba(144, 238, 144, 1)' },  // สมส่วน
            { max: 54 + ((108 - 54) / (208 - 148)) * (height - 148), color: 'rgba(255, 255, 0, 1)' },   // น้ำหนักเกิน
            { max: 65 + ((129 - 65) / (208 - 148)) * (height - 148), color: 'rgba(255, 165, 0, 1)' },   // โรคอ้วน
        ];
        return thresholds.find(t => weight < t.max)?.color || 'rgba(255, 69, 0, 1)';  // โรคอ้วนขั้นรุนแรง
    };
    const calculateDensity = (data, xRange, yRange) => {
        let density = 0;
        data.forEach(point => {
            const [x, y] = point;
            if (x >= xRange[0] && x <= xRange[1] && y >= yRange[0] && y <= yRange[1]) {
                density++;
            }
        });
        return density;
    };


    const data_BMI1 = {
        datasets: [
            {
                label: "",
                type: 'scatter',
                data: bmiData_1.length > 0 ? bmiData_1.map(({ x, y }) => ({ x, y })) : [{ x: 0, y: 0 }],
                pointHoverRadius: 7,
                pointStyle: 'rectRot',
                pointBackgroundColor: ({ raw }) => {

                    if (!raw || raw.x === undefined || raw.y === undefined) {
                        return 'transparent';
                    }
                    return getPointColor(raw.x, raw.y);
                },
            },
            ...[
                {
                    label: 'ต่ำกว่าเกณฑ์',
                    color: 'rgba(206, 222, 239, 1)',
                    data: [
                        [148, 40], [163, 49], [178, 58], [193, 68], [208, 80]
                    ]
                },
                {
                    label: 'สมส่วน',
                    color: 'rgba(145, 196, 161, 1)',
                    data: [
                        [148, 48], [163, 58], [178, 69], [193, 81], [208, 95]
                    ]
                },
                {
                    label: 'น้ำหนักเกิน',
                    color: 'rgba(250, 214, 73, 1)',
                    data: [
                        [148, 54], [163, 66], [178, 79], [193, 93], [208, 108]
                    ]
                },
                {
                    label: 'โรคอ้วน',
                    color: 'rgba(230, 150, 95, 1)',
                    data: [
                        [148, 65], [163, 79], [178, 95], [193, 111], [208, 129]
                    ]
                },
                {
                    label: 'โรคอ้วนขั้นรุนแรง',
                    color: 'rgba(213, 92, 92, 1)',
                    data: [
                        [148, 165], [163, 165], [178, 165], [193, 165], [208, 165]
                    ]
                }
            ].map(({ label, color, data }) => ({
                label,
                type: 'line',
                data: data.map(([x, y]) => ({ x, y })),
                borderColor: 'white',
                backgroundColor: color,
                borderWidth: 2,
                fill: true,
                pointRadius: 0,
                tension: 0.8,
            }))
        ]
    };


    const options_BMI1 = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'top',
                labels: {
                    usePointStyle: true,
                    filter: function (legendItem, chartData) {

                        return legendItem.text !== '';
                    }
                }

            },
            tooltip: {
                enabled: false
            }, title: {
                display: true,
                text: 'ครั้งที่ 1',
            },
        },
        scales: {
            x: {
                title: {
                    text: 'Height (CM)',
                    display: true,

                },
                type: 'linear',
                position: 'bottom',
                min: 148,
                max: 208,
                ticks: {
                    stepSize: 10,
                    font: {
                        size: 10,
                    },
                },
            },
            y: {
                title: {
                    text: 'Weight (KG)',
                    display: true,

                },
                beginAtZero: true,
                min: 25,
                max: 165,
                ticks: {
                    stepSize: 20,
                    font: {
                        size: 10,
                    },
                },

            },
        },
    };

    const data_BMI2 = {
        datasets: [
            {
                label: "",
                type: 'scatter',
                data: bmiData_2.length > 0 ? bmiData_2.map(({ x, y }) => ({ x, y })) : [{ x: 0, y: 0 }],
                pointHoverRadius: 7,
                pointStyle: 'rectRot',
                pointBackgroundColor: ({ raw }) => {

                    if (!raw || raw.x === undefined || raw.y === undefined) {
                        return 'transparent';
                    }
                    return getPointColor(raw.x, raw.y);
                },
            },
            ...[
                {
                    label: 'ต่ำกว่าเกณฑ์',
                    color: 'rgba(206, 222, 239, 1)',
                    data: [
                        [148, 40], [163, 49], [178, 58], [193, 68], [208, 80]
                    ]
                },
                {
                    label: 'สมส่วน',
                    color: 'rgba(145, 196, 161, 1)',
                    data: [
                        [148, 48], [163, 58], [178, 69], [193, 81], [208, 95]
                    ]
                },
                {
                    label: 'น้ำหนักเกิน',
                    color: 'rgba(250, 214, 73, 1)',
                    data: [
                        [148, 54], [163, 66], [178, 79], [193, 93], [208, 108]
                    ]
                },
                {
                    label: 'โรคอ้วน',
                    color: 'rgba(230, 150, 95, 1)',
                    data: [
                        [148, 65], [163, 79], [178, 95], [193, 111], [208, 129]
                    ]
                },
                {
                    label: 'โรคอ้วนขั้นรุนแรง',
                    color: 'rgba(213, 92, 92, 1)',
                    data: [
                        [148, 165], [163, 165], [178, 165], [193, 165], [208, 165]
                    ]
                }
            ].map(({ label, color, data }) => ({
                label,
                type: 'line',
                data: data.map(([x, y]) => ({ x, y })),
                borderColor: 'white',
                backgroundColor: color,
                borderWidth: 2,
                fill: true,
                pointRadius: 0,
                tension: 0.8,
            }))
        ]
    };

    const options_BMI2 = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: true,
                position: 'top',
                labels: {
                    usePointStyle: true,
                    filter: function (legendItem, chartData) {

                        return legendItem.text !== '';
                    }
                }

            },
            tooltip: {
                enabled: false
            }, title: {
                display: true,
                text: 'ครั้งที่ 2',
            },
        },
        scales: {
            x: {
                title: {
                    text: 'Height (CM)',
                    display: true,

                },
                type: 'linear',
                position: 'bottom',
                min: 148,
                max: 208,
                ticks: {
                    stepSize: 10,
                    font: {
                        size: 10,
                    },
                },
            },
            y: {
                title: {
                    text: 'Weight (KG)',
                    display: true,

                },
                beginAtZero: true,
                min: 25,
                max: 165,
                ticks: {
                    stepSize: 20,
                    font: {
                        size: 10,
                    },
                },

            },
        },
    };

    return (

        <div className="col-12 m-0 p-0 pt-2 ">

            <div className="card ">
                <div className="card-body col-12 pt-3">
                    {loading ? (
                        <LoadingTable />
                    ) :
                        // chartReady ? (

                        <div>
                            <h5 className="card-title fw-bold text-start">BMI<span>|  ณ {thai_date(DateTime, "shortdate")}</span></h5>
                            <div className="d-flex row" >
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-1">

                                    <div className="card-body">
                                        <div className="align-items-center d-flex justify-content-center" style={{ height: "350px", border: "5px solid white", backgroundColor: "rgba(206, 222, 239, 0.2)" }}>

                                            {bmiData1.length === 0 ? (
                                                <h5 className="card-title fw-bold text-start">ไม่มีข้อมูลวงรอบปี {yearcurrent + 543} ครั้งที่ 1 </h5>
                                            ) : (

                                                <>
                                                    <Scatter data={data_BMI1} options={options_BMI1} />
                                                </>



                                            )}
                                        </div>
                                    </div>

                                </div>
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-1">

                                    <div className="card-body">
                                        <div className="align-items-center d-flex justify-content-center" style={{ height: isStacked ? "400px" : "350px", border: "5px solid white", backgroundColor: "rgba(206, 222, 239, 0.2)" }}>

                                            {bmiData1.length === 0 ? (
                                                <h5 className="card-title fw-bold text-start">ไม่มีข้อมูลวงรอบปี {yearcurrent + 543} ครั้งที่ 1 </h5>
                                            ) : (

                                                <div className='col-12 '>
                                                    <p style={{ fontWeight: "bold", fontSize: "14px" }}> ครั้งที่ 1</p>
                                                    <div className="col-12  d-flex justify-content-center">
                                                        <img src={bmi} className="rounded img-fluid" style={{ maxHeight: "150px", width: "50%" }} />
                                                    </div>
                                                    <div className="col-12 d-flex justify-content-center p-0 ">

                                                        <table responsive className={isStacked ? 'table-stacked' : 'table_content table table-hover'} style={{ width: "65%" }}>
                                                            <thead >
                                                                <tr style={{ verticalAlign: "middle" }}>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(206, 222, 239, 1)" }}>ต่ำกว่าเกณฑ์</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(145, 196, 161, 1)" }}>สมส่วน</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(250, 214, 73, 1)" }}>น้ำหนักเกิน</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(230, 150, 95, 1)" }}>โรคอ้วน</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(213, 92, 92, 1)" }}>โรคอ้วนขั้นรุนแรง</th>

                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                <tr className="raw " >
                                                                    <td className="text-center " data-label="ต่ำกว่าเกณฑ์" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(206, 222, 239, 1)" }} >
                                                                        {bmiDatasummary1.count_18_22} คน
                                                                        <div> (
                                                                            {(
                                                                                (bmiDatasummary1.count_18_22 /
                                                                                    (bmiDatasummary1.count_18_22 +
                                                                                        bmiDatasummary1.count_22_25 +
                                                                                        bmiDatasummary1.count_25_30 +
                                                                                        bmiDatasummary1.count_30_35 +
                                                                                        bmiDatasummary1.count_35_plus)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="สมส่วน" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(145, 196, 161, 1)" }}>
                                                                        {bmiDatasummary1.count_22_25} คน
                                                                        <div>(
                                                                            {(
                                                                                (bmiDatasummary1.count_22_25 /
                                                                                    (bmiDatasummary1.count_18_22 +
                                                                                        bmiDatasummary1.count_22_25 +
                                                                                        bmiDatasummary1.count_25_30 +
                                                                                        bmiDatasummary1.count_30_35 +
                                                                                        bmiDatasummary1.count_35_plus)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="น้ำหนักเกิน" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(250, 214, 73, 1)" }}>
                                                                        {bmiDatasummary1.count_25_30} คน
                                                                        <div>(
                                                                            {(
                                                                                (bmiDatasummary1.count_25_30 /
                                                                                    (bmiDatasummary1.count_18_22 +
                                                                                        bmiDatasummary1.count_22_25 +
                                                                                        bmiDatasummary1.count_25_30 +
                                                                                        bmiDatasummary1.count_30_35 +
                                                                                        bmiDatasummary1.count_35_plus)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="โรคอ้วน" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(230, 150, 95, 1)" }}>
                                                                        {bmiDatasummary1.count_30_35} คน
                                                                        <div>(
                                                                            {(
                                                                                (bmiDatasummary1.count_30_35 /
                                                                                    (bmiDatasummary1.count_18_22 +
                                                                                        bmiDatasummary1.count_22_25 +
                                                                                        bmiDatasummary1.count_25_30 +
                                                                                        bmiDatasummary1.count_30_35 +
                                                                                        bmiDatasummary1.count_35_plus)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="โรคอ้วนขั้นรุนแรง" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(213, 92, 92, 1)" }}>
                                                                        {bmiDatasummary1.count_35_plus} คน
                                                                        <div>(
                                                                            {(
                                                                                (bmiDatasummary1.count_35_plus /
                                                                                    (bmiDatasummary1.count_18_22 +
                                                                                        bmiDatasummary1.count_22_25 +
                                                                                        bmiDatasummary1.count_25_30 +
                                                                                        bmiDatasummary1.count_30_35 +
                                                                                        bmiDatasummary1.count_35_plus)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>

                                                                </tr>


                                                            </tbody>
                                                        </table> </div>

                                                </div>







                                            )}
                                        </div>
                                    </div>

                                </div>
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-1">

                                    <div className="card-body">
                                        <div className="align-items-center d-flex justify-content-center" style={{ height: "350px", border: "5px solid white", backgroundColor: "rgba(206, 222, 239, 0.2)" }}>
                                            {bmiData2.length === 0 ? (<h5 className="card-title fw-bold text-start">ไม่มีข้อมูลวงรอบปี {yearcurrent + 543} ครั้งที่ 2 </h5>
                                            ) : (

                                                <Scatter data={data_BMI2} options={options_BMI2} />
                                            )}
                                        </div>
                                    </div>

                                </div>
                                <div className="col-xxl-6 col-xl-6 col-lg-12 col-md-12 col-sm-12 m-0 p-1">

                                    <div className="card-body">
                                        <div className="align-items-center d-flex justify-content-center" style={{ height: isStacked ? "400px" : "350px", border: "5px solid white", backgroundColor: "rgba(206, 222, 239, 0.2)" }}>

                                            {bmiData2.length === 0 ? (
                                                <h5 className="card-title fw-bold text-start">ไม่มีข้อมูลวงรอบปี {yearcurrent + 543} ครั้งที่ 2 </h5>
                                            ) : (

                                                <div className='col-12 '>
                                                    <p style={{ fontWeight: "bold", fontSize: "14px" }}> ครั้งที่ 2</p>
                                                    <div className="col-12  d-flex justify-content-center">
                                                        <img src={bmi} className="rounded img-fluid" style={{ maxHeight: "150px", width: "50%" }} />
                                                    </div>
                                                    <div className="col-12 d-flex justify-content-center p-0">
                                                        <table responsive className={isStacked ? 'table-stacked' : 'table_content table table-hover'} style={{ width: "65%" }}>
                                                            <thead >
                                                                <tr style={{ verticalAlign: "middle" }}>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(206, 222, 239, 1)" }}>ต่ำกว่าเกณฑ์</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(145, 196, 161, 1)" }}>สมส่วน</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(250, 214, 73, 1)" }}>น้ำหนักเกิน</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(230, 150, 95, 1)" }}>โรคอ้วน</th>
                                                                    <th scope="col" style={{ fontSize: "12px", verticalAlign: "middle", textAlign: "center", width: "10%", minWidth: "20px", backgroundColor: "rgba(213, 92, 92, 1)" }}>โรคอ้วนขั้นรุนแรง</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>

                                                                <tr className="raw " >
                                                                    <td className="text-center " data-label="ต่ำกว่าเกณฑ์" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(206, 222, 239, 1)" }} >
                                                                        {bmiDatasummary2.count_18_22} คน
                                                                        <div> (
                                                                            {(
                                                                                (bmiDatasummary2.count_18_22 /
                                                                                    (bmiDatasummary2.count_18_22 +
                                                                                        bmiDatasummary2.count_22_25 +
                                                                                        bmiDatasummary2.count_25_30 +
                                                                                        bmiDatasummary2.count_30_35 +
                                                                                        bmiDatasummary2.count_35_plus)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="สมส่วน" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(145, 196, 161, 1)" }}>
                                                                        {bmiDatasummary2.count_22_25} คน
                                                                        <div>(
                                                                            {(
                                                                                (bmiDatasummary2.count_22_25 /
                                                                                    (bmiDatasummary2.count_18_22 +
                                                                                        bmiDatasummary2.count_22_25 +
                                                                                        bmiDatasummary2.count_25_30 +
                                                                                        bmiDatasummary2.count_30_35 +
                                                                                        bmiDatasummary2.count_35_plus)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="น้ำหนักเกิน" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(250, 214, 73, 1)" }}>
                                                                        {bmiDatasummary2.count_25_30} คน
                                                                        <div>(
                                                                            {(
                                                                                (bmiDatasummary2.count_25_30 /
                                                                                    (bmiDatasummary2.count_18_22 +
                                                                                        bmiDatasummary2.count_22_25 +
                                                                                        bmiDatasummary2.count_25_30 +
                                                                                        bmiDatasummary2.count_30_35 +
                                                                                        bmiDatasummary2.count_35_plus)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="โรคอ้วน" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(230, 150, 95, 1)" }}>
                                                                        {bmiDatasummary2.count_30_35} คน
                                                                        <div>(
                                                                            {(
                                                                                (bmiDatasummary2.count_30_35 /
                                                                                    (bmiDatasummary2.count_18_22 +
                                                                                        bmiDatasummary2.count_22_25 +
                                                                                        bmiDatasummary2.count_25_30 +
                                                                                        bmiDatasummary2.count_30_35 +
                                                                                        bmiDatasummary2.count_35_plus)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>
                                                                    <td className="text-center" data-label="โรคอ้วนขั้นรุนแรง" style={{ fontSize: "12px", verticalAlign: "middle", backgroundColor: "rgba(213, 92, 92, 1)" }}>
                                                                        {bmiDatasummary2.count_35_plus} คน
                                                                        <div>(
                                                                            {(
                                                                                (bmiDatasummary2.count_35_plus /
                                                                                    (bmiDatasummary2.count_18_22 +
                                                                                        bmiDatasummary2.count_22_25 +
                                                                                        bmiDatasummary2.count_25_30 +
                                                                                        bmiDatasummary2.count_30_35 +
                                                                                        bmiDatasummary2.count_35_plus)) *
                                                                                100
                                                                            ).toFixed(2)}%)
                                                                        </div>
                                                                    </td>

                                                                </tr>


                                                            </tbody>
                                                        </table>

                                                    </div>
                                                </div>







                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        // )
                        // : null
                    }
                </div>

            </div>
        </div>





    );
};

export default BMIChartComponent;
